import type { ColumnFilterElementTemplateOptions } from 'primereact/column';
import { Dropdown, type DropdownProps } from 'primereact/dropdown';

interface ColumnDropdownFilterOption<T> {
    label: string;
    value: T | null;
}

interface ColumnDropdownFilterProps<T> {
    options: ColumnFilterElementTemplateOptions;
    filterOptions: Array<ColumnDropdownFilterOption<T>>;
    dropdownProps?: Omit<DropdownProps, 'value' | 'options' | 'onChange'>;
}

export const ColumnDropdownFilter = <T,>({
    options,
    filterOptions,
    dropdownProps,
}: ColumnDropdownFilterProps<T>) => {
    const selectedValue: unknown = options.value;

    return (
        <Dropdown
            value={selectedValue}
            options={filterOptions}
            onChange={(event) => {
                const nextValue: unknown = event.value;
                options.filterApplyCallback(nextValue);
            }}
            placeholder="All"
            className="p-column-filter"
            showClear
            style={{ minWidth: 140 }}
            {...dropdownProps}
        />
    );
};
